export default "__VITE_ASSET__OwW1$ylD__"